import { createLogger } from "@progressive-development/pd-utils";
//#region src/helper/logger.ts
var isValidLevel = (level) => [
	"debug",
	"info",
	"warn",
	"error"
].includes(level);
var ENV_LOG_LEVEL = void 0;
var defaultOptions = {
	level: isValidLevel(ENV_LOG_LEVEL) ? ENV_LOG_LEVEL : "info",
	isDev: false
};
/**
* Creates a logger with the application's environment configuration.
* Uses VITE_LOG_LEVEL and MODE from import.meta.env.
*
* @param context - Prefix for log messages (e.g., component or module name)
* @param options - Optional overrides for logger configuration
*/
var createLogger$1 = (context, options) => createLogger(context, {
	...defaultOptions,
	...options
});
/** Default logger instance for pd-spa-helper */
var defaultLogger = createLogger$1("PdSpa");
//#endregion
export { createLogger$1 as createLogger, defaultLogger };
